<div class="jobseeker-uploaded-document-item">
  <table>
    <tbody>
      <tr>
        <td>
          <form
            id="{{ 'doc_' + document.jobseekerDocumentId }}"
            action="{{ getDownloadUrl() }}"
            method="post"
            target="_blank"
          >
            <span>
              <a
                target="_blank"
                href="javascript:void(0)"
                (click)="
                  onDownloadUploadedDocumentClick(
                    'doc_' + document.jobseekerDocumentId
                  )
                "
                >{{ DocumentTypeEnum[document.type] | translate }}</a
              >
            </span>
          </form>
        </td>
        <td>{{ document.label }}</td>
        <td>{{ document.createDate | date : dateFormat }}</td>
        <td>
          <button
            (click)="onDeleteUploadedDocumentClick()"
            class="fa fa-times-circle btn btn-link"
          ></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
